import * as React from "react";
import styled from "styled-components";
import { toast } from "react-toastify";

import { Button } from "src/library/components/Button";
import { LoadingSpinner } from "src/library/components/LoadingSpinner";
import {
  BasicModal,
  BasicModalProps
} from "src/library/components/Modal/BasicModal";
import { ErrorNotice } from "src/core/shared/components/ErrorNotice";
import { useUserApi } from "src/core/users/api/users.api";

import { CustomerMultiSelect } from "./CustomerMultiSelect";

type CustomerDropsExportModalProps = Pick<BasicModalProps, "onDismiss" | "open">;

export const CustomerUserExportModal: React.ReactFCWithChildren<CustomerDropsExportModalProps> = ({ onDismiss, open }) => {
  const [ exportCustomerUserRes, exportCustomerUsers ] = useUserApi("EXPORT_CUSTOMER_USER");
  const [ userExportFilters, setUserExportFilters ] = React.useState<number[]>([]);

  // handle the response and open the file to trigger the download
  React.useEffect(() => {
    if (exportCustomerUserRes.data) {
      setUserExportFilters([]);
      onDismiss();
      toast.success(exportCustomerUserRes.data.message);
    }
  // Ignore other dependencies, we only care for the defined ones below
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ exportCustomerUserRes.data ]);

  return (
    <StyledBasicModal
      title="Export Customer Users"
      open={open}
      onDismiss={() => {
        setUserExportFilters([]);
        onDismiss();
      }}
    >
      {exportCustomerUserRes.error && (
        <ErrorNotice
          message={exportCustomerUserRes.error.message}
          type="error"
        />
      )}

      {exportCustomerUserRes.pending ? (
        <LoadingSpinner type="circular" />
      ) : (
        <>
          <CustomerMultiSelect
            onCustomersChange={({ fullCustomersSelected }) => setUserExportFilters(fullCustomersSelected.map(c => c.id))}
          />

          <Button
            className="submit-button"
            onClick={() => {
              exportCustomerUsers({ customerIds: userExportFilters });
            }}
          >
            Export
          </Button>
        </>
      )}
    </StyledBasicModal>
  );
};

const StyledBasicModal = styled(BasicModal)`
  .submit-button {
    margin-top: ${({ theme }) => theme.spacing.margins.md};
  }
`;